import React, {useEffect, useRef, useState} from 'react';
import ReactModal from 'react-modal';
import {useDispatch, useSelector} from 'react-redux';

import {
  ShowItemsSelect,
  Pagination,
  CustomDropdown,
  Message,
} from '../utilites';
import {
  getLeader,
  getDepartments,
  getBranches,
  addBranch,
  changeBranch,
  clearError,
  requestPut,
  deleteBranch,
  resetHandbook,
  getAdImage,
  openModal,
  returnFailedAdImage
} from '../../redux/actions/handbookAction';
import {pageOptions} from '../../helpers/data-constants';
import {HookForm} from '../../validation/HForm';
import ModalLayout from './ModalLayout/ModalLayout';
import Loader from './Loader/Loader';
import {permissionsAccess} from '../../helpers/common';

import './affiliates.scss';
import '../../assets/styles/components/_tables.scss';

import CrossIcon from '../../assets/icons/cross.svg';
import PlusIcon from '../../assets/icons/plus-small.svg';
import EditIcon from '../../assets/icons/edit.svg';
import DeleteIcon from '../../assets/icons/trash.svg';
import DocumentIcon from "../../assets/icons/document-clean.svg";
import {messages} from "../../helpers/messages";
import branchScheme from "../../validation/scheme/branchS ‎cheme";

const Affiliates = () => {
  const {
    leader,
    departments,
    branches,
    loading,
    errorMessage,
    advertImage,
    adImageName,
    isLoading,
    isModal,
    isPut,
    commonError,
    totalPages,
  } = useSelector(({handbook}) => handbook);
  const dispatch = useDispatch();
  const ref = useRef()

  const [currentPage, setCurrentPage] = useState(1);
  const [defaultData, setDefaultData] = useState(null);
  const [pageRange, setPageRange] = useState(pageOptions[0].value);
  const [fileName, setFileName] = useState('');
  const [previewImage, setPreviewImage] = useState('');
  const {accessFeatures} = useSelector(({user}) => user);
  const isMainEnable = accessFeatures['cash_box.main.enable']

  const allowedFileTypes = ["image/jpeg", "image/jpg"];
  const regFileName = new RegExp('^[a-zA-Zа-яА-ЯёЁ0-9.,-/;#~!№@&$%^-_+=(){}\'`\\[\\]\\s*]*$')
  const requiredWidth = 1052;
  const requiredHeight = 285;

  useEffect(() => {
    permissionsAccess("action.branch.create") && dispatch(getLeader(''));
    dispatch(getDepartments(''));

    return () => {
      dispatch(resetHandbook());
    };
  }, [dispatch]);

  useEffect(() => {
    permissionsAccess("action.branch.list") && dispatch(getBranches(pageRange, currentPage));
  }, [dispatch, pageRange, currentPage]);

  useEffect(() => {
    if (advertImage) {
      const base64 = `data:image/jpeg;base64,${advertImage}`
      setPreviewImage(base64)
      setFileName(adImageName)
    }
  }, [advertImage, adImageName])

  const handleOpenModal = () => dispatch(openModal());

  const handleCloseModal = () => {
    setDefaultData(null);
    dispatch(clearError());
    accessFeatures['report.advert'] && isPut && handleDeleteAdImage()
  }

  const handleRemoveInput = () => {
    ref.current.value = "";
  }

  const handleDeleteAdImage = () => {
    setPreviewImage('')
    setFileName('')
    handleRemoveInput()
  }

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file && allowedFileTypes.includes(file.type)) {
      const reader = new FileReader();
      if (file.name.length <= 40 && regFileName.test(file.name)) {

        if (file.size < 5242880) {
          reader.onloadend = () => {
            const image = new Image();
            image.onload = () => {
              if (image.width <= requiredWidth && image.height <= requiredHeight) {
                setFileName(file.name);
                setPreviewImage(reader.result);
                dispatch(returnFailedAdImage(null));
              } else {
                dispatch(returnFailedAdImage(`Размер рекламной вставки должен быть не больше ${requiredWidth}px в ширину и ${requiredHeight}px в высоту`))
              }
            }
            image.src = reader.result;
          }
        } else {
          dispatch(returnFailedAdImage(messages[16800]))
        }
      } else {
        dispatch(returnFailedAdImage(file.name.length <= 40 ? messages[16802] : messages[16801]))
      }
      reader.readAsDataURL(file);
    } else {
      dispatch(returnFailedAdImage(messages[16803]))
    }
    handleRemoveInput()
  };

  const handleSubmit = ({branchName, directorIds, listCashboxes, sendUserAllowed}) => {
    const branchId = defaultData && defaultData.branchId;
    const payload = {
      data: {
        branchName,
        directorIds: directorIds.map((i) => i.value),
        cashBoxIds: listCashboxes.map((item) => item.value),
        sendUserAllowed: sendUserAllowed?.value
      },
      branchId: branchId,
      size: pageRange,
      page: currentPage,
      image: {
        name: fileName,
        branchId: branchId,
        advertImage: previewImage
      },
      editAccess: permissionsAccess("action.branch.update"),
      reportAdvert: accessFeatures['report.advert'],
      dataPrint: {
        dealId: null,
        dealType: "purity",
        cashBoxIds: null,
        branchId: branchId
      }
    };
    if (isPut) {
      dispatch(changeBranch(payload))
      setDefaultData(null);
    } else {
      dispatch(addBranch(payload));
    }
  };

  const handlePageChange = (page) => setCurrentPage(page);

  const handleOptionsLeader = (e, action) => {
    if (action.action === 'input-change') dispatch(getLeader(e));
  };

  const handleOptionsBranch = (e, action) => {
    if (action.action === 'input-change') dispatch(getDepartments(e));
  };

  const handleChange = (props) => {
    dispatch(requestPut());
    !isPut && permissionsAccess("action.advert.details") && dispatch(getAdImage(props.branchId))
    setDefaultData({...props});
  };

  const onPageRangeChange = ({target: {value}}) => {
    setPageRange(() => parseInt(value));
    setCurrentPage(1);
  };

  const handleDelete = (branchId) => {
    if (branches.length === 1) {
      if (currentPage > 1) {
        dispatch(deleteBranch(branchId, pageRange, currentPage - 1));
        setCurrentPage(currentPage - 1);
      } else {
        dispatch(deleteBranch(branchId, pageRange, currentPage));
      }
    } else {
      dispatch(deleteBranch(branchId, pageRange, currentPage));
    }
  };
  const trimLongFileName = (fileName) => {
    if (fileName.length > 50) {
      return fileName.slice(0, 50) + '... .' + fileName.split('.').pop()
    }
    return fileName
  }
  return (
    <>
      {commonError && <Message type={'error'} text={commonError}/>}
      <div className="content-inner-data-container">
        <div className="content-datatable">
          <div className="content-datatable-header sticky">
            <div className="d-flex flex-column align-center fullwidth">
              <div className="content-datatable-header-actions d-flex">
                <div className="content-datatable-header-right">
                  <div className="action-items">
                    <ShowItemsSelect options={pageOptions} change={onPageRangeChange}/>
                  </div>
                  <div className="action-items">
                    {permissionsAccess("action.branch.create") && (
                      <button
                        className="button-icontrigger-accent caption hover"
                        onClick={handleOpenModal}>
                          <span className="icon">
                            <PlusIcon/>
                          </span>
                        <span>Создать филиал</span>
                      </button>
                    )}
                    <ReactModal
                      isOpen={isModal}
                      contentLabel="Modal"
                      className="modal-container affiliates-modal"
                      overlayClassName="modal-overlay">
                      <HookForm onSubmit={handleSubmit}
                                validationSchema={branchScheme(isMainEnable)}
                                submitOnEnterPress={true}>
                        <div className="modal-header">
                          <h2>{isPut ? 'Редактирование филиала' : 'Создание нового филиала'}</h2>
                          <button
                            className="button-icontrigger modal-closetrigger"
                            onClick={handleCloseModal}>
                              <span className="icon">
                                <CrossIcon/>
                              </span>
                          </button>
                        </div>
                        <div className="modal-body affiliates-modal-body">
                          {errorMessage &&
                            <div className="affiliates-error"><Message type={'error'} text={errorMessage}/>
                            </div>}
                          {!permissionsAccess("action.branch.update") && <div className="hiding-div"></div>}
                          <ModalLayout
                            h="true"
                            defaultData={defaultData}
                            loading={loading}
                            leader={leader}
                            departments={departments}
                            isMainEnable={isMainEnable}
                            handleOptionsLeader={handleOptionsLeader}
                            handleOptionsBranch={handleOptionsBranch}
                          />
                        </div>
                        {accessFeatures['report.advert'] && (<div className="modal-body">
                          {isPut && (
                            <div>
                              <input className='hidden' id='advertImage' type="file"
                                     accept=".jpeg, .jpg"
                                     onChange={handleFileChange} ref={ref}/>
                              <div className='file-name-container'>
                                {!loading && fileName && <div>
                                  <span className="icon">
                                    <DocumentIcon/>
                                  </span>
                                  <span
                                    className='file-name'>{trimLongFileName(fileName)}</span>
                                  <button
                                    type="button"
                                    className="button-icontrigger"
                                    onClick={() => {
                                      handleDeleteAdImage()
                                    }}>
                                    <span className="icon">
                                      <DeleteIcon/>
                                    </span>
                                  </button>
                                </div>}
                              </div>
                              {previewImage && <div>{!loading &&
                                <img className='advertImage' src={previewImage} alt="Preview"/>}</div>}
                            </div>
                          )}
                        </div>)}
                        {accessFeatures['report.advert'] ? (
                            <div className="modal-footer affiliates-modal-footer">
                              {isPut &&
                                <div className="modal-footer"><label className="button"
                                  htmlFor="advertImage">Загрузить рекламу</label></div>}
                              <div className="modal-footer">
                                <button className="button">Сохранить</button>
                                <button className="button-light" onClick={handleCloseModal}>
                                  Отменить
                                </button>
                              </div>
                            </div>) :
                          (<div className="modal-footer">
                            <button className="button">Сохранить</button>
                            <button className="button-light" onClick={handleCloseModal}>
                              Отменить
                            </button>
                          </div>)}
                      </HookForm>
                    </ReactModal>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="content-datatable-content datatable-branch">
            {isLoading ? (
              <Loader pageRange={pageRange}/>
            ) : (
              <table className="table hover" id="departments">
                <thead>
                <tr>
                  <th scope="col">Филиал</th>
                  <th scope="col">Директор</th>
                  <th scope="col" colSpan="2">
                    Подразделения
                  </th>
                </tr>
                </thead>
                <tbody className="affiliates">
                {branches &&
                  branches.length !== 0 &&
                  branches.map((props) => {
                    return (
                      <tr key={props.branchId}>
                        <td>
                          <p>{props.branchName}</p>
                        </td>
                        <td>
                          <p>{props.directors?.map((i) => i.fullName).join(', ')}</p>
                        </td>
                        <td>
                          <p>{props.cashBoxes.map(({name}) => name).join(', ')}</p>
                        </td>
                        <td className="dropdown-col">
                          <div className="table-cell-actions">
                            {(permissionsAccess("action.branch.update") || permissionsAccess('action.advert.details')) &&
                              (<button
                                className="button-icontrigger"
                                onClick={() => {
                                  handleOpenModal()
                                  handleChange(props)
                                }}>
                                  <span className="icon">
                                    <EditIcon/>
                                  </span>
                              </button>)}
                            {permissionsAccess("action.branch.delete") && <CustomDropdown
                              triggerText={null}
                              additionalClasses={'affiliates'}
                              headText={'Вы точно хотите удалить филиал?'}
                              onAction={handleDelete}
                              props={props.branchId}
                              buttonText={'Удалить'}>
                              <DeleteIcon/>
                            </CustomDropdown>}
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            )}
          </div>
        </div>
      </div>
      <Pagination
        total={totalPages}
        current={currentPage}
        handlePageChange={handlePageChange}
      />
    </>
  );
};

export default Affiliates;
